import React, { Fragment } from 'react';
import { noop } from 'lodash';
import { Button } from 'Components/frameworks/button/Button';
type Props = Partial<{
  button?: {
    color?: Colors;
    label: string;
    link?: string;
    onClick: () => void;
  };
  children?: Node;
  dataSelector: string;
  label?: string;
}>;
export const OverlaidActionProvider = ({
  button = {},
  children,
  dataSelector = 'OverlaidActionProvider',
  label,
}: Props) => {
  const shouldRender = (button.onClick && button.onClick !== noop) || button.link;

  if (!shouldRender) {
    return null;
  }

  return (
    <Fragment>
      <div data-selector={`${dataSelector}--oapOuterContent`}>{children}</div>
      <div className="mt-20 flex flex-col items-center">
        {!!label && (
          <div className="font-brand text-20" data-selector={`${dataSelector}--oapLabel`}>
            {label}
          </div>
        )}
        <Button className="m-5" data-selector={`${dataSelector}-button`} size="medium" {...button}>
          {button.label}
        </Button>
      </div>
    </Fragment>
  );
};
